import { useTranslation } from 'react-i18next';

export type BdsLanguage = 'pt_BR' | 'en_US' | 'es_ES';

const LANGUAGE_MAP: Record<string, BdsLanguage> = {
  en: 'en_US',
  es: 'es_ES',
  pt: 'pt_BR',
};

/**
 * Hook to get the mapped language string for Blip DS components
 * based on the current i18next language.
 */
export const useBdsLanguage = (): BdsLanguage => {
  const { i18n } = useTranslation();
  
  return LANGUAGE_MAP[i18n.language] || LANGUAGE_MAP.pt;
};
